import React from "react";

const LazyMeetings = React.lazy(() => import("./Meetings").then((module) => ({ default: module.Meetings })));

export default LazyMeetings;
